import React from 'react'
import Hero from './components/hero'

function Project() {
  return (
    <div>
      <Hero />
    </div>
  )
}

export default Project
